import api from "../services/api"
import { toast } from "react-toastify"
import { serializeLeadFilters } from "../utils/leadFilters"


const getStagesDetails = async (funnel_id, filters = '') => {
    try {
        if (funnel_id) {
            const queryString = serializeLeadFilters(filters)
            const response = await api.get(`/funnels/${funnel_id}/stages/details?${queryString}`)
            const stages = response.data?.data
            return stages
        } else {
            return []
        }
    } catch (err) {
        toast.error(err?.response?.data?.message)
    }
}

const getStages = async (funnel_id) => {
    try {
        if (funnel_id) {
            const response = await api.get(`/funnels/${funnel_id}/stages`)
            const stages = response.data?.data
            return stages
        } else {
            return []
        }
    } catch (err) {
        toast.error(err?.response?.data?.message)
    }
}

export { getStages, getStagesDetails }
